<template>
	<div class="building">
		<p>页面未找到，请检查链接</p>
	</div>
</template>
<script>
export default {
	name: 'building',
	data: function(){
		return {
		}
	},
	created: function(){
	},
	methods: {
	}
}
</script>

<style scoped>
.building{ padding-top: 100px; text-align: center;}
.building p{ font-size: 24px; line-height: 200%; color: #000;}
</style>


// WEBPACK FOOTER //
// src/components/building.vue